import {
  format,
  parse,
  isSameDay,
  isSameMonth,
  eachWeekOfInterval,
  startOfMonth,
  endOfMonth,
  startOfWeek,
  endOfWeek,
  differenceInWeeks,
  addWeeks,
} from 'date-fns';

import { DATE_FORMAT_INTERNAL, WEEK_OFFSET } from './constants';
import logger from 'itrvl-logger';

const log = logger(__filename);
log.trace(__filename);

export const formatDate = date => format(date, DATE_FORMAT_INTERNAL);
export const parseDate = dateString => parse(dateString, 'yyyy-M-d', new Date());

export const getDateString = (segment = {}) => {
  const { startDate, endDate } = segment;
  if (!startDate || !endDate) {
    return '';
  }
  if (isSameDay(startDate, endDate)) {
    return format(startDate, 'MMM d');
  }
  if (isSameMonth(startDate, endDate)) {
    return `${format(startDate, 'MMM d')} - ${format(endDate, 'd')}`;
  }
  return `${format(startDate, 'MMM d')} - ${format(endDate, 'MMM d')}`;
};

/**
 * Generates the bounds for the calendar fetch. As the calendar is set to be fixed height, each month
 * includes ${WEEK_OFFSET} worth of weeks (padding from previous to next month).
 * We fill this padding in to the bounds
 * @todo: We can trim this at some point and potentially use an infinite/paged query instead
 * @param {*} date
 * @returns
 */
export const getCalendarBounds = date => {
  const start = startOfWeek(startOfMonth(date));
  let end = endOfWeek(endOfMonth(date));
  let diff = differenceInWeeks(end, start);
  while (diff < WEEK_OFFSET) {
    end = addWeeks(end, 1);
    diff = differenceInWeeks(end, start);
  }
  return [start, end];
};

export const isAvailable = (avail, provisionalAvail) => avail > 0 || avail === -2 || avail === -1 || (avail === 0 && provisionalAvail > 0);

export const travelersToFillRoom = (room, maxAdults, maxChildren) => {
  const { minPax, guestNormal, normalAdults, normalChildren } = room;
  const totals = {
    adults: 0,
    children: 0,
    adultsErr: undefined,
    minErr: undefined,
  };

  if (maxAdults === 0 && maxChildren > 0) {
    totals.adultsErr = true;
    return totals;
  }

  // assign 1 adult, as its required
  totals.adults = 1;

  if (maxChildren > normalChildren) {
    totals.children = normalChildren;
  }

  if (maxChildren <= normalChildren) {
    totals.children = maxChildren;
  }

  if (totals.children > guestNormal) {
    totals.children = guestNormal;
  }

  // now we need to fill in remainder adults
  if (totals.children + totals.adults < guestNormal) {
    let remainder = guestNormal - (totals.children + totals.adults);
    if (remainder > 0 && normalAdults > totals.adults) {
      // normalAdults -
      totals.adults = Math.min(remainder + 1, normalAdults, maxAdults);
    }
  }

  if (totals.adults + totals.children < minPax) {
    return {
      adults: 0,
      children: 0,
      adultsErr: undefined,
      minErr: true,
    };
  }

  return totals;
};

export const generateDatesByWeek = date => {
  let datesByWeek = eachWeekOfInterval({
    start: startOfWeek(startOfMonth(date)),
    end: endOfWeek(endOfMonth(date)),
  });

  return datesByWeek;
};

export function adultsChildrenText(adults = 0, children = 0) {
  return [
    adults > 0 && `${adults} ${adults === 1 ? 'Adult' : 'Adults'}`,
    children > 0 && `${children} ${children === 1 ? 'Child' : 'Children'}`,
  ]
    .filter(Boolean)
    .join(', ');
}
